import { AxiosResponse } from "axios";
import httpClient from "../../api/httpClient";
import EstoqueBRF from "../classes/EstoqueBRF";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET", rota: "EstoqueBRF/All/RecuperarPorFiltro" },
  { method: "POST", rota: "EstoqueBRF/Adicionar" },
  { method: "PUT", rota: "EstoqueBRF/Atualizar" },
  { method: "DELETE", rota: "EstoqueBRF/Apagar" },
];

const cacheKey: string = "EstoqueEmbalagensCache";
const cacheKeySelC: string = "EstoqueEmbalagensSelecionado";

const apiServico: string = "PEDIDOS";

export default class EstoqueBRFDataset extends httpClient {
  constructor() {
    super(apiServico);
  }

  async getAll(centro: string): Promise<EstoqueBRF[]> {
    let ok: boolean = false;
    let data: EstoqueBRF[] = [];
    let error: any = undefined;
    let url = `${calls[0].rota}?centro=${centro}`;
    await super
      .Get(url)
      .then((response: AxiosResponse) => {
        ok = response.status == 200;
        data = EstoqueBRF.fromJson(response.data);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<EstoqueBRF[]>((resolve) => {
      resolve(data);
    });
  }

  async add(value: EstoqueBRF) {
    let ok: boolean = false;
    let error: any = undefined;
    super
      .post(calls[1].rota, value)
      .then((result) => {
        ok = JSON.parse(result);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
  }

  async update(value: EstoqueBRF): Promise<boolean> {
    let ok: boolean = false;
    let error: any = undefined;
    super
      .put(calls[2].rota, EstoqueBRF.toJson(value))
      .then((response: AxiosResponse) => {
        ok = response.status == 200;
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<boolean>((resolve) => {
      resolve(ok);
    });
  }

  async remove(value: EstoqueBRF): Promise<boolean> {
    let ok: boolean = false;
    let error: any = undefined;
    await super
      .delete(calls[3].rota, EstoqueBRF.toJson(value))
      .then((response: AxiosResponse) => {
        ok = response.status == 200;
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<boolean>((resolve) => {
      resolve(ok);
    });
  }

  getKeyCache(): string {
    return cacheKey;
  }

  getKeyCacheSelected(): string {
    return cacheKeySelC;
  }

  getAllFromCache(): EstoqueBRF[] {
    let result: EstoqueBRF[] = JSON.parse(cacheKey);
    return result;
  }

  addResultsToCache(value: EstoqueBRF[]) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

  clearCache() {
    localStorage.removeItem(cacheKey);
  }

  clearSelectedItemFromCache() {
    localStorage.removeItem(cacheKeySelC);
  }
}
